import React, {Component} from 'react'
import PageHeaderWrapper from '../../../../components/PageHeaderWrapper'
import {TableComp} from 'sz-react-utils'
import moment from 'moment/moment'
import ListFollowUps from '../../../../components/_utils/listFollowUp'

import {Avatar, Card, notification, Select, Tooltip, Checkbox, Button} from 'antd/lib/index'
import Request from '../../../../request'

import {connect} from 'react-redux'
import styles from './styles.less'
import {getUrlPushWrapper} from '../../../../routes'
import common from '../../../common.less'
import LatestFollowUp from '../../../../components/_utils/latestFollowup'
import MoveToPrevDesk from '../../../../components/_utils/moveToPrevDesk'
import Settings from '../../../../components/_utils/settings'

import lodash from 'lodash'

import SMS from '../../../../components/communication/sms'
import WhatsAPPSMS from '../../../../components/communication/WhatsAppSms'
import EmailDrawer from '../../../../components/communication/emailDrawer'
let dateFormat = localStorage.getItem('company-details')?JSON.parse(localStorage.getItem('company-details')).dateFormat:'DD.MM.YYYY';
let studentObj = {};
let userCheckBox = {}
let counsellingData = {}

const Option = Select.Option

class RegistrationDesk extends Component {
    state = {
        count: 0,
        showFollowUp: false,
        studentId: null,
        branchId: '',
        counsellorId: '',
        allBranches: [],
        allCounsellor: [],
        deskColor: null,
        showSMS: false,
        showWhatsAppSms: false,
        showEmail: false,
        userCheckBox: {},
    }
    showSMS = () => {
          let userArr = lodash.filter(this.state.userCheckBox, (item) => {
              return item.isChecked
          })
          if (userArr && userArr.length) {
              counsellingData = {
                  usersData: userArr
              }
              this.setState({showSMS: true})
          } else {
              notification.error({
                  message: 'Please select atleast 1 user.'
              })
          }
      }
      closeSMS = () => {
          this.setState({showSMS: false})
      }
      showWhatsAppSms = () => {
          let userArr = lodash.filter(this.state.userCheckBox, (item) => {
              return (item.isChecked == true?item:false);
          })

          if (userArr && userArr.length) {
              counsellingData = {
                  usersData: userArr
              }
              this.setState({showWhatsAppSms: true})
          } else {
              notification.error({
                  message: 'Please select atleast 1 user.'
              })
          }
      }
      closeWhatsSMS = () => {
          this.setState({showWhatsAppSms: false})
      }
      closeEmail = () => {
          this.setState({showEmail: false})
      }
      showEmail = () => {
          let userArr = lodash.filter(this.state.userCheckBox, (item) => {
              return item.isChecked
          })
          if (userArr && userArr.length) {
              counsellingData = {
                  usersData: userArr
              }
              this.setState({showEmail: true})
          } else {
              notification.error({
                  message: 'Please select atleast 1 user.'
              })
          }
      }
      selectUser = (item, studentId) => {
          let cloneUserCheckBox = lodash.clone(this.state.userCheckBox)
          if (cloneUserCheckBox[studentId] == undefined) {
            cloneUserCheckBox[studentId] = [];
          }
          cloneUserCheckBox[studentId].isChecked = !cloneUserCheckBox[studentId].isChecked
          this.setState({userCheckBox: cloneUserCheckBox})
      }
      selectAllUserFxn = () => {
          let cloneUserCheckBox = lodash.clone(this.state.userCheckBox)
          lodash.each(cloneUserCheckBox, (item) => {
              item.isChecked = true
          })
          this.setState({userCheckBox: cloneUserCheckBox})
      }
      unselectAllUserFxn = () => {
          let cloneUserCheckBox = lodash.clone(this.state.userCheckBox)
          lodash.each(cloneUserCheckBox, (item) => {
              item.isChecked = false
          })
          this.setState({userCheckBox: cloneUserCheckBox})
      }
    apiRequest = (params, columns) => {
        return new Promise(async resolve => {
            // params.count = 200

            if (!params.sortField) {
                params.sortField = 'id'
                params.sortOrder = 'descend'
            }

            if (this.state.counsellorId) {
                params.counsellorId = this.state.counsellorId
                params.page = 1
            }
            if (this.state.branchId) {
                params.studentBranchId = this.state.branchId
                params.page = 1
            }

            params.atLevel = ['Dead Inquiry']

            if (params.dateOfBirth && params.dateOfBirth.length > 0) {
                var splitDate = params.dateOfBirth[0].split('-');
                const monthNames = ["January", "February", "March", "April", "May", "June",
                    "July", "August", "September", "October", "November", "December"
                ];
                var monthName = monthNames[splitDate[1] - 1];

                params.dateOfBirth = splitDate[0] + '-' + monthName + '-' + splitDate[2];

                const stringToDate = new Date(params.dateOfBirth);
                params.dateOfBirth = {
                    $gte: stringToDate.setHours(0, 0, 0),
                    $lt: stringToDate.setHours(23, 59, 59),
                };
            } else {
                delete params.dateOfBirth
            }

            let data = await Request.loadCounselling({
                ...params,
                regExFilters: ['studentName', 'mobile', 'email', 'updatedByUser.name', 'createdByUser.name']
            })

            delete data.error
            delete data.type

            lodash.each(data.data, (item) => {
              if (!userCheckBox[item._id]) {
                  userCheckBox[item._id] = {
                      _id: item._id,
                      emailId: item.emailId,
                      mobile: item.mobile,
                      studentName: item.studentName,
                      isChecked: false
                  }
              }
            })

            this.setState({count: data.total, allBranches: data.allBranches, userCheckBox: userCheckBox})
            resolve(data)
        })
    }
    closeFollowUp = () => {
        this.setState({showFollowUp: false})
    }
    openFollowUps = record => {
        studentObj = {
            arr: record.followUp,
            name: record.studentName,
            rating: record.counsellingDesk.rating,
            subRating: record.counsellingDesk.subRating,
            _id: record._id
        }
        this.setState({showFollowUp: true})
    }
    renderStatus = (val) => {

        if (val === 'Super Hot') {
            return <div className={styles.SuperHot}>{val.toUpperCase()}</div>
        }
        if (val === 'Fit2Apply') {
            return <div className={styles.Fit2Apply}>{val.toUpperCase()}</div>
        }

        if (val === 'Luke Warm') {
            return <div className={styles.LukeWarm}>{val.toUpperCase()}</div>
        }

        if (val === 'Potential') {
            return <div className={styles.Potential}>{val.toUpperCase()}</div>
        }

        if (val === 'Dead') {
            return <div className={styles.dead}>{val.toUpperCase()}</div>
        }

        if (val === 'Cold') {
            return <div className={styles.Cold}>{val.toUpperCase()}</div>
        }


    }

    constructor(props) {
        super(props)
        this.table = React.createRef()
    }

    componentWillMount() {
        this.setState({deskColor: Settings.deskColor('Dead Inquiry')})
    }

    async componentDidMount() {
        let {data: allCounsellor} = await Request.loadUser({results: 10000})


        this.setState({
            allCounsellor,

        })
    }

    render() {
        const {dispatch} = this.props
        const {allBranches = [], allCounsellor = [], deskColor} = this.state;

        const columns = [
            {
                title: 'Action',
                key: 'operation',
                dataindex: 'operation',
                width: 100,
                fixed: true,
                render: (text, record) => (
                    <React.Fragment>
                        <span className={styles.userSelectCheckbox}>
                          <Checkbox
                              checked={userCheckBox[record._id] ? userCheckBox[record._id].isChecked : false}
                              onChange={y => {
                                  this.selectUser(y, record._id)
                              }}>
                          </Checkbox>
                        </span>
                        <MoveToPrevDesk type={'popconfirm'} text={'Restore'}
                                        _id={record._id} atLevel="Front Desk" done={() => {

                            notification.success({
                                message: 'Send to Counselling Desk'
                            })
                            this.table.current.reload()
                        }}
                        />

                    </React.Fragment>
                )
            },

            {
                title: 'VID',
                key: 'id',
                dataIndex: 'id',
                sorter: true,
                width: 80,
                fixed: true,
                searchTextName: 'id',
                filterRegex: true
            },
            {
                title: 'Student Name',
                key: 'studentName',
                dataIndex: 'studentName',
                width: 160,
                fixed: true,
                sorter: true,
                searchTextName: 'studentName',
                filterRegex: true,
                render: (text, record) => (
                    <React.Fragment>
                        <Tooltip title="Click To View Student">
                            <a
                                className={styles.btn}
                                onClick={() => {
                                    dispatch(
                                        getUrlPushWrapper('inquiry.edit1', {
                                            id: record._id
                                        })
                                    )
                                }}
                            >{text}</a>
                        </Tooltip>
                    </React.Fragment>
                )
            },
            {
                title: 'Photo',
                key: 'profilePic',
                width: 60,
                dataIndex: 'profilePic',
                render: val => {
                    return (
                        <Avatar src={val}/>
                    )
                }
            },

            {
                title: 'Follow Up',
                key: 'followUp',
                width: 200,
                dataIndex: 'followUp',
                render: (text, record) => {
                    return <LatestFollowUp info={text}/>
                }
            },
            {
                title: 'DOB',
                width: 100,
                key: 'dateOfBirth',
                dataIndex: 'dateOfBirth',
                searchTextName: `${dateFormat}`,
                render: (val, record) => {
                    return (
                        <div>
                            {record.dateOfBirth
                                ? moment(record.dateOfBirth).format(dateFormat)
                                : ''}
                        </div>
                    )
                }
            },
            {
                title: 'Source',
                key: 'source',
                dataIndex: 'location'
            },
            /*  {
                title: 'Rating',
                key: 'rating',
                dataIndex: 'counsellingDesk.rating',
                render: (val, record) => {
                  return this.renderStatus(val)

                }
              },*/
            {
                title: 'MOB/WAP/Mail',
                key: 'mobwap',
                dataIndex: 'mobwap',
                searchTextName: 'MOB/WAP/Mail',
                render: (val, record) => {
                    return (
                        <div>
                            <div>
                                <span>{record.mobile}</span>
                            </div>
                            <div>
                                {record.watsupp && record.watsupp.length == 10 ?
                                    <Tooltip title="Share on Whatsapp">
                                        <a target={'_blank'}
                                           style={{textDecoration: 'underline'}}
                                           href={`http://api.whatsapp.com/send?phone=91${record.watsupp}&text=&source=&data=`}>{record.watsupp}</a>
                                    </Tooltip>
                                    : record.watsupp}
                            </div>
                            <div>
                                <span>{record.emailId}</span>
                            </div>
                        </div>
                    )
                }
            },
            {
                title: 'Test Score',
                key: 'ieltsOverallScore',
                dataIndex: 'ieltsOverallScore',
                width: 180,
                render: (text, record) => {
                    return (
                        <div style={{fontSize: '12px'}}>

                            <div
                                style={{paddingBottom: '4px'}}> {record.testType && text ? `${record.testType} OverAll : ${text}` : null}</div>
                            <div
                                style={{paddingBottom: '4px'}}>{record && record.profile && record.profile.reading ? `Reading : ${record.profile.reading}` : null} {record && record.profile && record.profile.writing ? `Writing : ${record.profile.writing}` : null} </div>
                            <div>{record && record.profile && record.profile.listening ? `Listening : ${record.profile.listening}` : null} {record && record.profile && record.profile.speaking ? `Speaking : ${record.profile.speaking}` : null}</div>


                        </div>
                    )
                }
            },
            {
                title: 'Preference',
                key: 'preference',
                render: (val, row) => {
                    return row.totalPreference ? (
                        <ul className={common.ul}>
                            {row.totalPreference.map((val, inde) => {
                                return <li key={inde}>{val.country}</li>
                            })}
                        </ul>
                    ) : null
                }
            },
            {
                title: 'Counsellor',
                key: 'counsellorId',
                // filters: allCounsellor.map(x => ({value: x._id, text: x.name})),
                render: (text, record) => {
                    return (
                        <div>{record.counsellorId ? record.counsellorId.name : ''}</div>
                    )
                }
            },
            {
                title: 'Branch',
                key: 'studentBranchId',
                filters: allBranches,

                render: (text, record) => {
                    return (
                        <div>
                            {record.studentBranchId ? record.studentBranchId.branchName : ''}
                        </div>
                    )
                }
            },
            {
                title: 'Last Updated By',
                width: 150,
                key: 'updatedByUser',
                dataIndex: 'updatedByUser',
                searchTextName: 'updatedByUser',

                render: (text, record) => {
                    return (
                        <div>
                            <div className={common.user}>{text ? text.name : ''}</div>
                            <small>{text ? moment(text.time).format('lll') : ''}</small>
                        </div>
                    )
                }
            },
            // {
            //   title: 'Created By',
            //   width: 150,
            //   key: 'createdByUser',
            //   dataIndex: 'createdByUser',
            //   searchTextName: 'createdByUser',
            //   render: (text, record) => {
            //     return (
            //       <div>
            //         <div className={common.user}>{text ? text.name : ''}</div>
            //         <small>{text ? moment(text.time).format('lll') : ''}</small>
            //       </div>
            //     )
            //   }
            // }
        ]
        return (
            <PageHeaderWrapper deskColor={deskColor} title={` DEAD INQUIRY : ${this.state.count} `}>
                {this.state.showFollowUp ? (
                    <ListFollowUps studentObj={studentObj} onClose={this.closeFollowUp}/>
                ) : null}

                {/*  <Card style={{ marginBottom: 10 }}>
          <div style={{ display: 'flex' }}>
            <h5 className="search_title" style={{ paddingTop: 8 }}>
              SEARCH BY COUNSELLOR
            </h5>
            <Select
              showSearch
              allowClear
              style={{
                width: 214,
                paddingRight: 16,
                paddingLeft: 9
              }}
              value={this.state.counsellorId}
              placeholder="Select Counsellor"
              onChange={counsellorId => {
                this.setState(
                  { counsellorId: counsellorId && counsellorId.toString() },
                  () => {
                    this.table.current.reload()
                  }
                )
              }}
              filterOption={(input, option) => {
                return (
                  option.props.children
                    .toLowerCase()
                    .indexOf(input.toLowerCase()) >= 0
                )
              }}>
              {allCounsellor.map((val, idn) => {
                return (
                  <Option key={idn} value={val._id}>
                    {val.name}
                  </Option>
                )
              })}
            </Select>
            <h5 className="search_title" style={{ paddingTop: 8 }}>
              SEARCH BY BRANCH
            </h5>
            <Select
              showSearch
              allowClear
              style={{
                width: 214,
                paddingRight: 16,
                paddingLeft: 9
              }}
              value={this.state.branchId}
              placeholder="Select Branch"
              onChange={branchId => {
                this.setState(
                  { branchId: branchId && branchId.toString() },
                  () => {
                    this.table.current.reload()
                  }
                )
              }}
              filterOption={(input, option) => {
                return (
                  option.props.children
                    .toLowerCase()
                    .indexOf(input.toLowerCase()) >= 0
                )
              }}>
              {allBranches.map((val, idn) => {
                return (
                  <Option key={idn} value={val._id}>
                    {val.branchName}
                  </Option>
                )
              })}
            </Select>
          </div>
        </Card>*/}
            {this.state.showWhatsAppSms ? (
                <WhatsAPPSMS counsellingData={counsellingData} onClose={this.closeWhatsSMS}/>
            ) : null}

            {this.state.showSMS ? (
                <SMS counsellingData={counsellingData} onClose={this.closeSMS}/>
            ) : null}

            {this.state.showEmail ? (
                <EmailDrawer counsellingData={counsellingData} onClose={this.closeEmail}/>
            ) : null}
            <Card style={{marginBottom: 10}}>
              <div className={styles.filterBlock}>
                <div className={styles.myBtnGroup}>
                  <div className="antd-pro-containers-student-inquiry-all-styles-myBtnGroup">
                    <Button
                        className={styles.btn}
                        type="primary"
                        onClick={() => this.showEmail()}>Send E-mail
                    </Button>
                    <Button
                        type="primary"
                        className={styles.btn}
                        onClick={() => this.showSMS()}>Send SMS
                    </Button>
                    <Button
                        type="primary"
                        className={styles.btn}
                        onClick={() => this.showWhatsAppSms()}>Whatsapp
                    </Button>
                    <Button
                        className={styles.btn}
                        onClick={() => this.selectAllUserFxn()}>Select Visible
                    </Button>
                    <Button
                        className={styles.btn}
                        onClick={() => this.unselectAllUserFxn()}>Unselect Visible
                    </Button>
                  </div>
                </div>
              </div>
            </Card>
                <Card bordered={true}>
                    <TableComp
                        id={"deadInquiries"}
                        showSelector={true}
                        columns={columns}
                        ref={this.table}
                        apiRequest={this.apiRequest}
                        extraProps={{scroll: {x: 1800}}}
                        pagination={{
                            showSizeChanger: true,
                            defaultPageSize: 20,
                            pageSizeOptions: ['10', '20', '50', '100', '1000']
                        }}
                    />
                </Card>
            </PageHeaderWrapper>
        )
    }
}

const mapStateToProps = ({global}) => ({
    categories: global.categories
})
const mapDispatchToProps = dispatch => {
    return {
        dispatch
    }
}

export default connect(
    mapStateToProps,
    mapDispatchToProps
)(RegistrationDesk)
